import React from 'react';
import { Phone, Mail, MessageSquare, CheckCircle, PauseCircle, XCircle, AlertCircle } from 'lucide-react';
import { Button } from '../../../components/ui/button';

const fmtDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return dateStr;
};

export const EnquiriesTab = ({ enquiries, updateBookingStatus }) => {
  return (
    <div data-testid="enquiries-content">
      <div className="flex items-center gap-3 mb-6">
        <AlertCircle size={24} className="text-amber-600" />
        <h3 className="font-serif text-lg font-semibold text-[#1C2A20]">New Enquiries ({enquiries.length})</h3>
      </div>
      {enquiries.length === 0 ? (
        <div className="bg-[#FFFFFF] p-12 rounded-lg border border-[#2F5233]/30 text-center">
          <MessageSquare size={48} className="text-[#CBD8C2] mx-auto mb-4" />
          <h3 className="font-serif text-xl text-[#1C2A20] mb-2">No Pending Enquiries</h3>
          <p className="text-[#5E6E60]">All enquiries have been processed.</p>
        </div>
      ) : (
        <div className="grid gap-4">
          {enquiries.map(enquiry => (
            <div key={enquiry.id} className="bg-[#FFFFFF] p-6 rounded-lg border border-[#2F5233]/30" data-testid={`enquiry-${enquiry.id}`}>
              <div className="flex flex-wrap justify-between items-start gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h4 className="font-semibold text-lg text-[#1C2A20]">{enquiry.guest_name}</h4>
                    <span className="status-badge status-pending">Pending</span>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-[#5E6E60] mb-3">
                    <div className="flex items-center gap-2"><Phone size={14} />{enquiry.phone}</div>
                    {enquiry.email && <div className="flex items-center gap-2 text-xs truncate"><Mail size={14} /><span className="truncate">{enquiry.email}</span></div>}
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
                    <div><span className="text-[#5E6E60]">Room:</span> <span className="font-medium capitalize">{enquiry.room_type}</span></div>
                    <div><span className="text-[#5E6E60]">Guests:</span> <span className="font-medium">{enquiry.num_guests}</span></div>
                    <div><span className="text-[#5E6E60]">Check-in:</span> <span className="font-medium">{fmtDate(enquiry.check_in_date)}</span></div>
                    <div><span className="text-[#5E6E60]">Check-out:</span> <span className="font-medium">{fmtDate(enquiry.check_out_date)}</span></div>
                  </div>
                  {enquiry.special_requests && (
                    <p className="mt-3 text-sm text-[#5E6E60] bg-[#EEF1EA] p-3 rounded"><strong>Special Requests:</strong> {enquiry.special_requests}</p>
                  )}
                  <p className="text-xs text-[#5E6E60] mt-3">Received: {new Date(enquiry.created_at).toLocaleString('en-GB')}</p>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" onClick={() => updateBookingStatus(enquiry.id, 'confirmed')} className="bg-green-600 hover:bg-green-700"><CheckCircle size={16} className="mr-1" /> Confirm</Button>
                  <Button size="sm" variant="outline" onClick={() => updateBookingStatus(enquiry.id, 'on_hold')} className="border-yellow-500 text-yellow-600 hover:bg-yellow-50"><PauseCircle size={16} className="mr-1" /> Hold</Button>
                  <Button size="sm" variant="outline" onClick={() => updateBookingStatus(enquiry.id, 'cancelled')} className="border-red-500 text-red-400 hover:bg-red-900/20"><XCircle size={16} className="mr-1" /> Reject</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
